import { createStore } from 'zustand'

import { AudioContextInitialState } from './state'
import { type IAudioContext, type IStoreProps } from './types'

const audioStore = ({ mediaUrl, audioReady }: IStoreProps) =>
    createStore<IAudioContext>(set => ({
        ...AudioContextInitialState,
        mediaUrl,
        audioReady,
        setAudioEnd: () =>
            set(state => ({ ...state, playing: false, fullyListened: true })),
        setPlaying: (payload: boolean) =>
            set(state => ({ ...state, playing: payload })),
        setFullyListened: (payload: boolean) =>
            set(state => ({ ...state, fullyListened: payload })),
        setListened: (payload: number) =>
            set(state => ({ ...state, listened: payload })),
        setCurrentTime: (payload: number) =>
            set(state => ({ ...state, currentTime: payload })),
        setDuration: (payload: number) =>
            set(state => ({ ...state, duration: payload })),
        setMediaUrl: (payload: string) =>
            set(state => ({ ...state, mediaUrl: payload }))
    }))

export { audioStore }
